(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["common-questions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('common-questions')) {
    class CommonQuestions extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.triggers = Array.from(this.querySelectorAll('[data-faq-trigger]'));
        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.toggleItem(trigger));
        });
      }

      toggleItem(trigger) {
        const item = trigger.closest('[data-faq-item]');
        if (!item) return;

        const willOpen = !item.classList.contains('is-open');

        if (willOpen && this.dataset.allowMultiple !== 'true') {
          this.querySelectorAll('[data-faq-item].is-open').forEach((openItem) => {
            if (openItem === item) return;
            openItem.classList.remove('is-open');
            openItem.querySelector('[data-faq-trigger]')?.setAttribute('aria-expanded', 'false');
          });
        }

        item.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      }
    }

    customElements.define('common-questions', CommonQuestions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('social-proof-slider')) {
    class SocialProofSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('[data-slider-track]');
        this.cards = Array.from(this.querySelectorAll('[data-slider-card]'));
        this.controls = this.querySelector('.social-proof-slider__controls');
        this.dotsContainer = this.querySelector('[data-slider-dots]');
        this.previousButton = this.querySelector('[data-slider-previous]');
        this.nextButton = this.querySelector('[data-slider-next]');
        this.currentPage = 0;

        if (!this.track || this.cards.length < 2) return;

        this.previousButton?.addEventListener('click', () => this.goToPage(this.currentPage - 1));
        this.nextButton?.addEventListener('click', () => this.goToPage(this.currentPage + 1));
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
        this.querySelectorAll('[data-video-play]').forEach((button) => {
          button.addEventListener('click', () => this.playVideo(button));
        });
        this.querySelectorAll('video').forEach((video) => {
          video.controls = false;
          video.addEventListener('click', () => this.pauseVideo(video));
          video.addEventListener('ended', () => this.pauseVideo(video, false));
        });

        this.resizeObserver = new ResizeObserver(() => this.buildPagination());
        this.resizeObserver.observe(this.track);
        this.buildPagination();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        clearTimeout(this.scrollEndTimer);
      }

      get perPage() {
        return window.matchMedia('(min-width: 750px)').matches ? 3 : 1;
      }

      get pageCount() {
        return Math.max(1, this.cards.length - this.perPage + 1);
      }

      buildPagination() {
        const pageCount = this.pageCount;
        this.currentPage = Math.min(this.currentPage, pageCount - 1);
        const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 1;

        if (this.controls) {
          this.controls.hidden = !hasOverflow;
          this.controls.setAttribute('aria-hidden', hasOverflow ? 'false' : 'true');
        }

        if (!this.dotsContainer) return;

        this.dotsContainer.replaceChildren();
        for (let index = 0; index < pageCount; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'social-proof-slider__dot';
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          dot.addEventListener('click', () => this.goToPage(index));
          this.dotsContainer.appendChild(dot);
        }
        this.updateControls();
      }

      goToPage(page) {
        const targetPage = Math.max(0, Math.min(page, this.pageCount - 1));
        const targetCard = this.cards[targetPage];
        if (!targetCard) return;
        this.currentPage = targetPage;
        this.scrollTargetPage = targetPage;
        this.track.scrollTo({ left: targetCard.offsetLeft, behavior: 'smooth' });
        this.updateControls();
      }

      onScroll() {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          if (this.scrollTargetPage !== undefined) {
            clearTimeout(this.scrollEndTimer);
            this.scrollEndTimer = setTimeout(() => {
              this.scrollTargetPage = undefined;
              this.updateControls();
            }, 150);
            return;
          }

          this.syncCurrentPageToScroll();
        });
      }

      syncCurrentPageToScroll() {
        const maxScrollLeft = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        let nearestPage = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        for (let page = 0; page < this.pageCount; page += 1) {
          const targetCard = this.cards[page];
          if (!targetCard) continue;
          const pageScrollLeft = Math.min(targetCard.offsetLeft, maxScrollLeft);
          const distance = Math.abs(pageScrollLeft - this.track.scrollLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestPage = page;
          }
        }

        this.currentPage = nearestPage;
        this.updateControls();
      }

      updateControls() {
        this.querySelectorAll('.social-proof-slider__dot').forEach((dot, index) => {
          const active = index === this.currentPage;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (this.previousButton) this.previousButton.disabled = this.currentPage === 0;
        if (this.nextButton) this.nextButton.disabled = this.currentPage >= this.pageCount - 1;
      }

      playVideo(button) {
        const card = button.closest('[data-slider-card]');
        const video = card?.querySelector('video');
        if (!video) return;
        this.querySelectorAll('video').forEach((otherVideo) => {
          if (otherVideo !== video) {
            otherVideo.pause();
            otherVideo.closest('[data-slider-card]')?.classList.remove('is-playing');
          }
        });
        video.controls = false;
        video.play();
        card.classList.add('has-started');
        card.classList.add('is-playing');
      }

      pauseVideo(video, shouldPause = true) {
        if (shouldPause) video.pause();
        video.controls = false;
        video.closest('[data-slider-card]')?.classList.remove('is-playing');
      }
    }

    customElements.define('social-proof-slider', SocialProofSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tips-and-considerations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tips-accordion]').forEach((accordion) => {
    if (accordion.dataset.animationReady === 'true') return;

    accordion.dataset.animationReady = 'true';

    const summary = accordion.querySelector('summary');
    const content = accordion.querySelector('.tips-considerations__content');
    const duration = 280;

    summary.addEventListener('click', (event) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      event.preventDefault();
      if (accordion.dataset.animating === 'true') return;

      accordion.dataset.animating = 'true';
      accordion.style.overflow = 'hidden';

      const startHeight = `${accordion.offsetHeight}px`;

      if (accordion.open) {
        accordion.animate(
          [
            { height: startHeight },
            { height: `${summary.offsetHeight}px` },
          ],
          { duration, easing: 'ease-in-out' }
        ).finished.then(() => {
          accordion.open = false;
          accordion.style.overflow = '';
          accordion.dataset.animating = '';
        });
      } else {
        accordion.open = true;
        const endHeight = `${summary.offsetHeight + content.offsetHeight}px`;

        accordion.animate(
          [
            { height: `${summary.offsetHeight}px` },
            { height: endHeight },
          ],
          { duration, easing: 'ease-in-out' }
        ).finished.then(() => {
          accordion.style.overflow = '';
          accordion.dataset.animating = '';
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
